// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__6uKVS","emails":"CreateEditClinics_emails__93Sxp","emailTagLabel":"CreateEditClinics_emailTagLabel__2HS__"};